import { useIntl, FormattedMessage } from "react-intl";
import iconDE from "../../intro/pages/language/german.svg";
import iconEN from "../../intro/pages/language/english.svg";
import iconCN from "../../intro/pages/language/chinese.svg";
import StandardRadioButton from "../../elements/buttons/standardRadioButton.jsx";
import iconFR from "../../intro/pages/language/france.svg";
import StandardInstruction from "../../elements/text/standardInstruction.component.jsx";
import {useEffect, useState} from "react";

export default function Language(props) {
  const [initLang] = useState(props.language)
  const intl = useIntl();

  useEffect(() => {

    return () => {
      props.loadCampuses(props.selectedCampuses);
    }
  }, [initLang])

  const languages = [
    {
      name: intl.formatMessage({ id: "welcome.languageSelectionGerman" }),
      key: "de",
      flag: <img src={iconDE} />,
    },
    {
      name: intl.formatMessage({ id: "welcome.languageSelectionFrench" }),
      key: "fr",
      flag: <img src={iconFR} />,
    },
    {
      name: intl.formatMessage({ id: "welcome.languageSelectionEnglish" }),
      key: "en",
      flag: <img src={iconEN} />,
    },
    /*{
      name: intl.formatMessage({ id: "welcome.languageSelectionChinese" }),
      key: "cn",
      flag: <img src={iconCN} />,
    }, */
  ];

  return (
    <div className="d-flex flex-column">
      <StandardInstruction className={"mb-4"}>{props.text}</StandardInstruction>
      <div className="d-flex flex-column">
        {languages.map((l) => (
          <div
            className="general-margin-bottom d-flex justify-content-between"
            key={l.key}
            onClick={() => props.setLanguage(l.key)}
          >
            <div>
              {l.flag}
              <span className="d-inline-block general-padding-large-horizontally">
                {l.name}
              </span>
            </div>
            <StandardRadioButton
              className={"standardRadioButton__settings"}
              selected={l.key === props.language}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
